import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import SNAPEligibilityDetails from '../../subdepartmentdetails/SNAPEligibility'


function SNAPEligibility() {

  useEffect(() => {
    document.getElementById("title").innerHTML="SNAP Eligibility || SNAP";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="SNAP"
            title="SNAP Eligibility"
            subtitledown="Department of Family & Children Services"
           />
            <SNAPEligibilityDetails/>
        </div>
    </>
  )
}

export default SNAPEligibility



